"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = require("../../runtime/dom");
var awsui_button_dropdown_1 = require("../button/awsui-button-dropdown");
var BreadcrumbGroupWrapper = /** @class */ (function (_super) {
    __extends(BreadcrumbGroupWrapper, _super);
    function BreadcrumbGroupWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Returns all links.
     *
     * To find a specific link use the `findBreadcrumbLink(n)` function as chaining `findBreadcrumbLinks().get(n)` can return unexpected results.
     * @see findBreadcrumbLink
     */
    BreadcrumbGroupWrapper.prototype.findBreadcrumbLinks = function () {
        return this.findAll('.awsui-breadcrumb-link');
    };
    /**
     * Returns a link for a given index.
     *
     * @param index 1-based link index
     */
    BreadcrumbGroupWrapper.prototype.findBreadcrumbLink = function (index) {
        // We insert the breadcrumb-ellipsis as the second element so we have to filter it out.
        // Unfortunately, there is no efficient CSS selector for it in CSS Selectors-3 spec.
        // In the future we can use li:nth-child(n of .awsui-breadcrumb-item) when Selectors-4 spec is supported https://caniuse.com/#feat=css-nth-child-of
        if (index > 1) {
            index++;
        }
        return this.find(".awsui-breadcrumb-item:nth-child(" + index + ") .awsui-breadcrumb-link");
    };
    BreadcrumbGroupWrapper.prototype.findDropdown = function () {
        return new awsui_button_dropdown_1.default(this.find('awsui-button-dropdown').getElement());
    };
    return BreadcrumbGroupWrapper;
}(dom_1.ComponentWrapper));
exports.default = BreadcrumbGroupWrapper;
//# sourceMappingURL=awsui-breadcrumb-group.js.map